var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLightbulb = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.25 18.125h-2.5a.625.625 0 1 0 0 1.25h2.5a.625.625 0 0 0 0-1.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.875 16.25h-3.75a.625.625 0 0 0 0 1.25h3.75a.625.625 0 1 0 0-1.25"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.43 2.449A6.21 6.21 0 0 0 10 .625a6.235 6.235 0 0 0-6.25 6.25c0 1.821.698 3.525 1.914 4.674l.17.16c.704.657 1.666 1.558 1.666 2.354V15a.625.625 0 0 0 .625.625h.938a.313.313 0 0 0 .312-.312v-4.578a.31.31 0 0 0-.2-.291 5 5 0 0 1-1.022-.561.625.625 0 1 1 .726-1.016c.289.205.845.508 1.121.508s.832-.304 1.122-.508a.625.625 0 0 1 .725 1.016 5 5 0 0 1-1.022.56.31.31 0 0 0-.2.291v4.579a.313.313 0 0 0 .313.312h.937A.625.625 0 0 0 12.5 15v-.937c0-.777.952-1.677 1.646-2.335l.192-.182c1.251-1.194 1.912-2.811 1.912-4.67a6.22 6.22 0 0 0-1.82-4.427"
  })));
};
export { SvgLightbulb as ReactComponent };